import React from 'react';
import logo from '../../img/logo-horizontal-positive.svg';
import { classNames } from 'primereact/utils';
import styles from './footer.module.scss'
import { useTranslation } from 'react-i18next';

export function Footer() {

    const { t } = useTranslation();

    return (
        <footer className={classNames(styles.footerContainer)}>
            <img className={classNames(styles.footerLogo)} alt="s" src={logo} />
            <div className={classNames(styles.footerLinkImprint)}><a className={classNames(styles.contextFontSmallL)} href="/imprint">{t('deTranslation.footerImprint.linkText')}</a></div>
            <div className={classNames(styles.footerLinkData)}><a className={classNames(styles.contextFontSmallL)} href="/dataprotection">{t('deTranslation.footerDataProtection.linkText')}</a></div>
            <div className={classNames(styles.footerLinkContact)}><a className={classNames(styles.contextFontSmallL)} href="/contact">{t('deTranslation.footerContact.linkText')}</a></div>
        </footer>
    );
}

export default Footer;
